import React, { useState, useEffect } from "react";
import {
  FaChevronLeft,
  FaChevronRight,
  FaUser,
  FaBook,
  FaHistory,
  FaShieldAlt,
  FaChartLine,
  FaTint,
  FaWater,
} from "react-icons/fa";

import LiveCharts from "./LiveCharts";
import Feedback from "./feedback";
import PrivacyPolicy from "./PrivacyPolicy";
import Profile from "./Profile";
import Home from "./Home";
import LeakDetection from "./LeakDetection";
import UserTracking from "./UserTracking";

import "../styles/Dashboard.css";

const Dashboard = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Home");
  const [leakAlerts, setLeakAlerts] = useState(2); // 🔔 Simulate 2 leak alerts

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  // Clear leak alert badge when user visits Leak Detection tab
  useEffect(() => {
    if (selectedTab === "LeakDetection") {
      setLeakAlerts(0);
    }
  }, [selectedTab]);

  return (
    <div className="dashboard">
      {/* Sidebar */}
      <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
        <button className="collapse-btn" onClick={toggleSidebar}>
          {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
        <ul>
          <li onClick={() => setSelectedTab("Home")}>
            <FaUser /> <span className={isCollapsed ? "hidden" : ""}>Home</span>
          </li>
          <li onClick={() => setSelectedTab("LiveChart")}>
            <FaChartLine /> <span className={isCollapsed ? "hidden" : ""}>Live Charts</span>
          </li>
          <li onClick={() => setSelectedTab("LeakDetection")} className="badge-wrapper">
            <FaTint />
            <span className={isCollapsed ? "hidden" : ""}>Leak Detection</span>
            {leakAlerts > 0 && !isCollapsed && (
              <span className="alert-badge">{leakAlerts}</span>
            )}
            {leakAlerts > 0 && isCollapsed && <span className="dot-badge"></span>}
          </li>
          <li onClick={() => setSelectedTab("UserTracking")}>
            <FaWater /> <span className={isCollapsed ? "hidden" : ""}>User Water Tracking</span>
          </li>
          <li onClick={() => setSelectedTab("Profile")}>
            <FaBook /> <span className={isCollapsed ? "hidden" : ""}>Profile</span>
          </li>
          <li onClick={() => setSelectedTab("Feedback")}>
            <FaHistory /> <span className={isCollapsed ? "hidden" : ""}>Feedback</span>
          </li>
          <li onClick={() => setSelectedTab("PrivacyPolicy")}>
            <FaShieldAlt /> <span className={isCollapsed ? "hidden" : ""}>Privacy Policy</span>
          </li>
        </ul>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {selectedTab === "Home" && <Home />}
        {selectedTab === "LiveChart" && <LiveCharts />}
        {selectedTab === "LeakDetection" && <LeakDetection />}
        {selectedTab === "UserTracking" && <UserTracking />}
        {selectedTab === "Profile" && <Profile userEmail="user@example.com" />}
        {selectedTab === "Feedback" && <Feedback />}
        {selectedTab === "PrivacyPolicy" && <PrivacyPolicy />}
      </div>
    </div>
  );
};

export default Dashboard;
